import Modal from "../../../../components/Modal";
import { Title, Subtitle, Cancel, Save, Actions } from "./styles";
import { connect, useDispatch } from "react-redux";
import { hideModal } from "../../../../store/actions/modal";
import PhoneNumberForm from "../../../../pages/components/PhoneNumberForm";
import { useOnboardingModals } from "../../index";

const Component = ({ userInformation, changeUserPhoneStates }) => {
  const dispatch = useDispatch();
  const { nextModal } = useOnboardingModals();

  const handleClose = () => {
    dispatch(hideModal());
    // Solo llamar nextModal si el usuario tiene un número de teléfono
    // (es decir, si completó la acción)
    if (userInformation?.phone_number) {
      nextModal();
    }
  };

  return (
    <Modal
      animation="fadeInSlideUp"
      name="modal-phone-number"
      width="480"
      showClose={!!userInformation?.phone_number}
      onClose={handleClose}
    >
      <Title>Registra tu teléfono</Title>
      <div style={{ height: 8 }} />
      <Subtitle>
        Ingresá tu teléfono para que podamos brindarte una experiencia más
        personalizada.
      </Subtitle>
      <div style={{ height: 28 }} />
      <PhoneNumberForm />
      <div style={{ height: 28 }} />

      <Actions>
        {!!userInformation?.phone_number && (
          <Cancel
            type="button"
            options={{
              skin: "purple",
              size: "lg",
              type: "outline",
            }}
            onClick={handleClose}
          >
            Cancelar
          </Cancel>
        )}

        <Save
          isSubmmiting={changeUserPhoneStates.loading}
          options={{
            type: "filled",
            size: "lg",
            skin: "purple",
          }}
          form="phone-number-form"
        >
          {userInformation?.phone_number ? "Cambiar mi número" : "Registrar mi número"}
        </Save>
      </Actions>
    </Modal>
  );
};

const state = ({ userStore }) => {
  const { data: userInformation } = userStore.information;
  const { states: changeUserPhoneStates } = userStore.changeUserPhone;

  return {
    changeUserPhoneStates,
    userInformation,
  };
};

export default connect(state)(Component);
